import { systemProduction } from '../solar/selectors';

export const getSRECs = (state) => {
    const {
        resiToggle,
    } = state.tax;


    let trecRate = 152;
    if (resiToggle === true) {
        trecRate = 91.2;
    }

    const recRate = 15;

    const { horizonLength } = state.settings;
    const { projectState } = state.projectaddress;

    const results = {};
    const systemProd = systemProduction(state);

    for (let year = 1; year <= horizonLength; year += 1) {
        let annualSRECValue = 0;
        const numberOfRecs = systemProd[year] / 1000;

        if (projectState === 3) {
            if (year === 1) {
                annualSRECValue = trecRate * numberOfRecs;
            } else if (year <= 15) {
                annualSRECValue = trecRate * numberOfRecs;
            } else if (year > 15) {
                annualSRECValue = recRate * numberOfRecs;
            }
        } else {
            annualSRECValue = 0;
        }


        results[year] = annualSRECValue;
    }
    return results;
};

export const fake = 0;



// WEBPACK FOOTER //
// ./src/containers/common/srecs/selectors.js